/* eslint react/jsx-filename-extension: 0 */
import React from "react";
import { Route, Switch } from "react-router-dom";
import CaseLookup from "./case-lookup";
import ReportForm from "./report-form";

const RoutingLogic = () => (
  <Switch>
    <Route exact path="/" component={CaseLookup} />
    <Route exact path="/report" component={ReportForm} />
  </Switch>
);

export default RoutingLogic;
